import { render, staticRenderFns } from "./AppDetailModal.vue?vue&type=template&id=01825bce&scoped=true"
import script from "./AppDetailModal.vue?vue&type=script&lang=js"
export * from "./AppDetailModal.vue?vue&type=script&lang=js"
import style0 from "./AppDetailModal.vue?vue&type=style&index=0&id=01825bce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01825bce",
  null
  
)

export default component.exports